import { defineNuxtPlugin } from '#app'
import { useToast } from '#ui/composables/useToast'
import type { Notification } from '#ui/types'
import { GoogleAnalytics } from '~/google_analytics/events'
import { EventParameter } from '~/google_analytics/events.enum'

export default defineNuxtPlugin(() => {
  if (!process.client) return

  const toast = useToast()

  // Prevent double patching (HMR safe)
  if ((toast as any).__trackingPatched) return
    ; (toast as any).__trackingPatched = true

  const originalAdd = toast.add.bind(toast)

  toast.add = (notification: Partial<Notification>) => {
    console.log('[Toast Tracker] Toast added:', notification)

    try {
      const toastMessage =
        notification.title ||
        notification.description ||
        'No title'

      GoogleAnalytics.toast({
        [EventParameter.TOAST_MESSAGE]: toastMessage,
      })

      console.log('[Toast Tracker] GA Events Sent ✅')
    } catch (err) {
      console.error('[Toast Tracker] GA send failed:', err)
    }

    const id = notification.id || Math.random().toString(36).slice(2)
    const fullNotification = { ...notification, id } as Notification

    if ((fullNotification as any).closableOutside) {
      nextTick(() => {
        setTimeout(() => {
          const container = document.getElementById(
            'toast-notification-container'
          )
          if (!container) return

          const toastEl = container.firstElementChild
          const inner = toastEl?.firstElementChild

          const handler = (e: MouseEvent) => {
            if (inner && !inner.contains(e.target as Node)) {
              toast.remove(id)
              document.removeEventListener('click', handler)
            }
          }

          document.addEventListener('click', handler)
        }, 100)
      })
    }

    return originalAdd(fullNotification)
  }
})